/* Hermes CRO QA layer — unpublished theme only, 2026-06-24.
   Adds high-confidence conversion, localization, education and trust improvements without changing live Shopify resources. */
(() => {
  const locale = ((window.Shopify && Shopify.locale) || document.documentElement.lang || '').toLowerCase();
  const isFr = locale.startsWith('fr') || location.pathname.startsWith('/fr-fr');
  const lang = isFr ? 'fr' : 'de';

  const t = {
    de: {
      homeTrustTitle: 'Warum Kundinnen Velvet Nails wählen',
      trust: ['Maniküre zu Hause', 'UV/LED-Lampe erforderlich', 'Kostenloser Versand ab 50 €', '30 Tage Geld-zurück-Garantie'],
      shopStarter: 'Starter-Set shoppen', shopColors: 'Farben entdecken', shopGuide: 'Anwendung ansehen',
      discoverTitle: 'Finde deinen perfekten Start',
      discoverIntro: 'Für den ersten Kauf sollte sofort klar sein, was du brauchst: Farbe, Lampe und eine einfache Anleitung.',
      cards: [
        ['Starter-Set', 'Alles für die erste Maniküre in einem Einstiegspaket.', '/products/mix-match-1'],
        ['UV Gel Strips', 'Wähle deine Farbe und trage sie zu Hause auf.', '/collections/all'],
        ['Anwendung', 'Schritt für Schritt vorbereiten, auftragen und aushärten.', '/pages/anleitungen']
      ],
      pdpIntroTitle: 'Studio-Look, ohne Termin',
      pdpIntro: 'UV Gel Strips für eine gepflegte Maniküre zu Hause. Wähle deine Farbe, bereite die Nägel vor und härte die Strips mit einer UV/LED-Lampe aus.',
      pdpChecklist: ['UV/LED-Lampe zum Aushärten nötig', 'Prep-Pad und Feile je nach Set/Packung prüfen', 'Ideal für schnelle Maniküre-Routinen zu Hause'],
      pdpNeed: 'Brauche ich eine Lampe?',
      pdpNeedText: 'Ja. UV Gel Strips müssen nach dem Auftragen unter einer UV/LED-Lampe ausgehärtet werden. Wenn du neu startest, ist das Starter-Set der sicherste Einstieg.',
      pdpBundle: 'Besser starten mit Set + Farbe',
      pdpBundleText: 'Für den ersten Versuch: Starter-Set mit deiner Lieblingsfarbe kombinieren und die Anleitung Schritt für Schritt nutzen.',
      pdpBundleCta: 'Starter-Set ansehen',
      cartTitle: 'Vor dem Checkout prüfen',
      cartBullets: ['Hast du eine UV/LED-Lampe?', 'Kostenloser Versand ab 50 € nutzen', 'Bei erster Bestellung: Starter-Set statt Einzelfarbe prüfen'],
      searchHint: 'Beliebte Suchen: French, Rot, Nude, Starter-Set, UV-Lampe',
      stockSafe: 'Auf Lager',
      addToCart: 'In den Warenkorb',
      checkout: 'Sicher zur Kasse'
    },
    fr: {
      homeTrustTitle: 'Pourquoi choisir Velvet Nails',
      trust: ['Manucure à la maison', 'Lampe UV/LED nécessaire', 'Livraison offerte dès 50 €', 'Garantie satisfait ou remboursé 30 jours'],
      shopStarter: 'Voir le kit de démarrage', shopColors: 'Découvrir les couleurs', shopGuide: 'Voir le guide de pose',
      discoverTitle: 'Bien commencer avec Velvet Nails',
      discoverIntro: 'Pour un premier achat, tout doit être évident : la couleur, la lampe et les étapes de pose.',
      cards: [
        ['Kit de démarrage', 'Le point d’entrée le plus simple pour réussir sa première pose.', '/fr-fr/products/mix-match-1'],
        ['Nail wraps gel UV', 'Choisissez votre couleur et réalisez la pose chez vous.', '/fr-fr/collections/all'],
        ['Guide de pose', 'Préparer, appliquer, catalyser : le rituel expliqué pas à pas.', '/fr-fr/pages/anleitungen']
      ],
      pdpIntroTitle: 'L’effet salon, sans rendez-vous',
      pdpIntro: 'Des nail wraps gel UV pour une manucure nette à la maison. Choisissez votre couleur, préparez vos ongles puis catalysez sous lampe UV/LED.',
      pdpChecklist: ['Lampe UV/LED nécessaire pour catalyser', 'Vérifier le contenu exact du set ou de la pochette', 'Pensé pour une routine manucure simple à la maison'],
      pdpNeed: 'Faut-il une lampe ?',
      pdpNeedText: 'Oui. Les nail wraps gel UV doivent être catalysés sous lampe UV/LED après la pose. Pour débuter, le kit de démarrage est l’entrée la plus rassurante.',
      pdpBundle: 'Mieux démarrer : kit + couleur',
      pdpBundleText: 'Pour une première pose plus simple, associez le kit de démarrage à votre couleur préférée et suivez le guide pas à pas.',
      pdpBundleCta: 'Voir le kit de démarrage',
      cartTitle: 'À vérifier avant de commander',
      cartBullets: ['Avez-vous une lampe UV/LED ?', 'Profiter de la livraison offerte dès 50 €', 'Pour une première pose : envisager le kit de démarrage'],
      searchHint: 'Recherches fréquentes : French, rouge, nude, kit de démarrage, lampe UV',
      stockSafe: 'En stock',
      addToCart: 'Ajouter au panier',
      checkout: 'Passer au paiement sécurisé'
    }
  }[lang];

  const once = (id, fn) => { if (document.documentElement.dataset[id]) return; document.documentElement.dataset[id] = '1'; fn(); };
  const html = (strings, ...vals) => strings.map((s,i)=>s+(vals[i]??'')).join('');
  const safePath = (p) => p;

  function after(el, node) { if (el && el.parentNode) el.parentNode.insertBefore(node, el.nextSibling); }
  function first(sel) { return document.querySelector(sel); }
  function make(tag, cls, content) { const el=document.createElement(tag); if(cls) el.className=cls; if(content) el.innerHTML=content; return el; }

  function improveText() {
    const replacements = [
      [/Beeilen Sie sich, nur noch\s*\d+\s*Artikel auf Lager\./gi, t.stockSafe],
      [/Hurry, only\s*\d+\s*items left in stock\./gi, t.stockSafe],
      [/Dépêchez-vous, il ne reste que\s*\d+\s*articles en stock\./gi, t.stockSafe],
      [/Dépêchez-vous, il ne reste que\s*\d+\s*article en stock\./gi, t.stockSafe],
      [/In Den Warenkorb Legen/g, t.addToCart],
      [/In den Warenkorb legen/g, t.addToCart],
      [/Zur Kasse/g, t.checkout],
      [/Checkout/g, t.checkout]
    ];
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(n){ return n.nodeValue.trim() && !['SCRIPT','STYLE','TEXTAREA'].includes(n.parentElement?.tagName) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
    });
    const nodes=[]; while(walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(n => { let v=n.nodeValue; replacements.forEach(([r,to]) => v=v.replace(r,to)); if(v!==n.nodeValue) n.nodeValue=v; });
  }

  function addHomepageCRO() {
    const isHome = document.body.classList.contains('index-template') || location.pathname === '/' || location.pathname === '/fr-fr' || location.pathname === '/fr-fr/';
    if (!isHome) return;
    // Homepage CRO is now a native Shopify section, editable from the theme editor.
    // If the editable section exists, do not inject the old hardcoded duplicate block.
    if (document.querySelector('[data-hermes-editable-cro]')) return;
    once('hermesHomeCro', () => {
      const hero = first('#MainContent > .shopify-section');
      const section = make('section', 'hermes-cro hermes-home-cro', html`
        <div class="hermes-cro__inner">
          <div class="hermes-trustline" aria-label="${t.homeTrustTitle}">
            <strong>${t.homeTrustTitle}</strong>
            ${t.trust.map(x=>`<span>${x}</span>`).join('')}
          </div>
          <div class="hermes-discovery">
            <div><p class="hermes-eyebrow">Velvet Nails</p><h2>${t.discoverTitle}</h2><p>${t.discoverIntro}</p></div>
            <div class="hermes-actions"><a href="${safePath(t.cards[0][2])}">${t.shopStarter}</a><a href="${safePath(t.cards[1][2])}">${t.shopColors}</a><a href="${safePath(t.cards[2][2])}">${t.shopGuide}</a></div>
          </div>
          <div class="hermes-cardgrid">${t.cards.map(c=>`<a class="hermes-card" href="${safePath(c[2])}"><strong>${c[0]}</strong><span>${c[1]}</span></a>`).join('')}</div>
        </div>`);
      after(hero, section);
    });
  }

  function addPdpCRO() {
    const isPdp = document.body.classList.contains('product-template') || location.pathname.includes('/products/');
    if (!isPdp) return;
    once('hermesPdpCro', () => {
      const price = first('.product__info-container .price, .product-info .price, [id^="price-"], .price');
      const box = make('div', 'hermes-pdp-proof', html`
        <p class="hermes-eyebrow">Velvet Nails</p>
        <h2>${t.pdpIntroTitle}</h2>
        <p>${t.pdpIntro}</p>
        <ul>${t.pdpChecklist.map(x=>`<li>${x}</li>`).join('')}</ul>`);
      after(price || first('h1'), box);

      const form = first('product-form, form[action*="/cart/add"], .product-form');
      const starter = make('div', 'hermes-pdp-bundle', html`<strong>${t.pdpBundle}</strong><p>${t.pdpBundleText}</p><a href="${isFr ? '/fr-fr/products/mix-match-1' : '/products/mix-match-1'}">${t.pdpBundleCta}</a>`);
      if (form) after(form, starter);

      const rowsParent = first('.product__accordion, .product-info, .product__info-container') || first('main');
      const need = make('div', 'hermes-pdp-note', html`<strong>${t.pdpNeed}</strong><p>${t.pdpNeedText}</p>`);
      if (rowsParent) rowsParent.appendChild(need);
    });
  }

  function addCartCRO() {
    const isCart = document.body.classList.contains('cart-template') || location.pathname.endsWith('/cart') || location.pathname.endsWith('/fr-fr/cart');
    if (!isCart) return;
    once('hermesCartCro', () => {
      const target = first('#MainContent .shopify-section, main');
      const box = make('aside', 'hermes-cart-check', html`<h2>${t.cartTitle}</h2><ul>${t.cartBullets.map(x=>`<li>${x}</li>`).join('')}</ul></aside>`);
      if (target) target.prepend(box);
    });
  }

  function addSearchCRO() {
    const isSearch = document.body.classList.contains('search-template') || location.pathname.includes('/search');
    if (!isSearch) return;
    once('hermesSearchCro', () => {
      const input = first('input[type="search"], input[name="q"]');
      if (input && !input.placeholder) input.placeholder = t.searchHint;
      const main = first('main');
      if (main) main.prepend(make('div','hermes-search-hint', t.searchHint));
    });
  }

  function run() { improveText(); addHomepageCRO(); addPdpCRO(); addCartCRO(); addSearchCRO(); }
  document.addEventListener('DOMContentLoaded', () => { run(); setTimeout(run, 300); setTimeout(run, 1200); });
  new MutationObserver(() => { clearTimeout(window.__hermesCroTimer); window.__hermesCroTimer = setTimeout(run, 80); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
